import PropTypes from "prop-types";
import React, { useEffect } from "react";
import Update from "../../../../assets/assets/delete.svg";
import Button from "../../../Button/Button";
import { connect } from "react-redux";
import Storage from "../../../../utils/storage";
import {
  submitRequestForm,
  uploadKey,
} from "../../../../redux/Actions/NipOnboardingActions";

export const assignUrlFunc = (state, uploadKey) => {
  const formData = new FormData();
  formData.append("key", state.public_key_url);
  uploadKey(formData);
  return "";
};

const UpdateKeys = (props) => {
  const {
    application,
    isSubmitting,
    submitApplication,
    uploadKey,
    keyUploaded,
    isUploadingKey,
    uploadSuccess,
    setState,
    state,
  } = props;

  const dataObject = Storage.get("data");
  const data = dataObject && JSON.parse(dataObject);
  const permitInfo = application && application.ip_permit_info;
  const permitInfoPublicKey = permitInfo && permitInfo.public_key;

  const checkStringType = (str) => {
    let status = str && str.endsWith(".key");
    return status;
  };

  const check = checkStringType(permitInfoPublicKey);

  useEffect(() => {
    if (check) {
      setState({
        ...state,
        uploaded: true,
        public_key_url: permitInfoPublicKey,
      });
    }
    // eslint-disable-next-line
  }, [permitInfoPublicKey]);

  const showWidget = (event) => {
    setState({
      ...state,
      public_key_url: event.target.files[0],
      uploaded: true,
    });
    assignUrl();
  };

  const assignUrl = () => {
    assignUrlFunc(state, uploadKey);
  };

  const removeFile = () => {
    setState({
      ...state,
      public_key_url: "",
      error: "Public key is required",
      uploaded: false,
    });
  };

  const block = state.public_key_url === "";
  const ifEmpty =
    keyUploaded &&
    Object.keys(keyUploaded).length === 0 &&
    keyUploaded.constructor === Object;

  const submitValues = () => {
    const type = "update";
    const payload = {
      application_id: application && application.application_id,
      test_ip: data && data.ip,
      prod_ip: data && data.production_ip,
      public_key: !ifEmpty ? keyUploaded : state.public_key_url,
    };
    submitApplication(payload, type);
  };

  const block2 = state.uploaded && !uploadSuccess && !check;

  return (
    <div className="nip-public-keys">
      <div>
        <div className="nip-integration-header">Update Public Keys</div>
        <br />
        <div className="nip-public-keys-bottom">
          <div className="nip-public-keys-bottom-upload">
            <div
              className={
                state.uploaded ? "nip-file-uploaded" : "nip-file-input"
              }
            >
              {state.uploaded ? (
                isUploadingKey ? (
                  <div className="uploaded-public2">
                    <span>Uploading keys...</span>
                  </div>
                ) : uploadSuccess || check ? (
                  <div className="uploaded-public">
                    <span>
                      {(state.public_key_url && state.public_key_url.name) ||
                        "Public Key"}
                    </span>
                    <div
                      className="uploaded-public-icon"
                      data-testid="delete"
                      onClick={() => removeFile()}
                    >
                      <img src={Update} alt="update" />
                    </div>
                  </div>
                ) : (
                  <div className="uploaded-public2">
                    <span>Failed to upload keys</span>

                    <span
                      className="retry-upload"
                      data-testid="retry-upload"
                      onClick={() => removeFile()}
                    >
                      Retry
                    </span>
                  </div>
                )
              ) : (
                <div className="label-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    data-testid="showWidget"
                    onChange={showWidget}
                    accept=".key"
                  />
                </div>
              )}
            </div>
            {state.error !== "" && block && (
              <p className="errors">{state.error}</p>
            )}
          </div>

          <div className="nip-public-keys-bottom-button">
            <Button
              className="button"
              type="submit"
              width="50%"
              height="50px"
              testId="submit"
              onClick={() => submitValues()}
              text={isSubmitting ? "SUBMITTING..." : "PROCEED"}
              disabled={block || isSubmitting || block2 || isUploadingKey}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

UpdateKeys.propTypes = {
  application: PropTypes.shape({
    application_id: PropTypes.any,
    ip_permit_info: PropTypes.any,
  }),
  isSubmitting: PropTypes.any,
  isUploadingKey: PropTypes.any,
  keyUploaded: PropTypes.any,
  setState: PropTypes.func,
  state: PropTypes.shape({
    error: PropTypes.string,
    public_key_url: PropTypes.shape({
      name: PropTypes.any,
    }),
    uploaded: PropTypes.any,
  }),
  submitApplication: PropTypes.func,
  uploadKey: PropTypes.func,
  uploadSuccess: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    isSubmitting: state.nipOnboarding.isSubmittingRequestForm,
    keyUploaded: state.nipOnboarding.key,
    isUploadingKey: state.nipOnboarding.isUploadingKey,
    uploadSuccess: state.nipOnboarding.uploadSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  submitApplication: (payload, type) =>
    dispatch(submitRequestForm(payload, type)),
  uploadKey: (payload) => dispatch(uploadKey(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateKeys);
